import React, { FC } from 'react';
import { Input } from 'view/component/Input/Input';
import { Label } from 'view/component/Label/Label';
import { UnidadesUFCCascader } from 'view/component/UnidadesUFCCascader/UnidadesUFCCascader';
import { VinculoServidor, VinculoServidorSelect } from './VinculoServidorSelect';
import { RestricaoUnidade, RestricaoUnidadeSelect } from './RestricaoUnidadeSelect';
import styled from 'styled-components';
import { BotaoCancelar, BotaoSalvar } from 'view/component/Botao/BotoesComuns';
import { ApiUnidadesUFC } from 'service/api/ufc/ApiUnidadesUFC';
import { FormikDebug } from 'view/component/Formulario/FormikDebug';
import { useDispatch } from 'react-redux';
import { ServidoresAction } from 'store/Servidores/Servidores.action';
import { BuscaServidoresFormularioType } from './BuscaServidoresFormulario.types';
import { Formulario } from 'view/component/Formulario/Formulario';
import { OperacaoFormularioBusca } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';
import { RestricoesBuscaServidoresFormulario } from 'business/formulario/RestricoesBuscaServidoresFormulario';


interface BuscaServidoresFormularioProps {
  onCancelar: () => void;
}

export const BuscaServidoresFormulario: FC<BuscaServidoresFormularioProps> = ({onCancelar}) => {
  const dispatch = useDispatch();

  const restricoes = useRestricoesFormulario(RestricoesBuscaServidoresFormulario);

  const buscar = (formulario: BuscaServidoresFormularioType) => dispatch(ServidoresAction.lista.iniciar(formulario));

  const parametrosFormik = {
    initialValues: {
      nome: '',
      situacao: VinculoServidor.ATIVO,
      unidadeExercicio: ApiUnidadesUFC.REITORIA,
      restricaoUnidade: RestricaoUnidade.BUSCA_ESTA_UNIDADE_E_SUB_UNIDADES,
    } as BuscaServidoresFormularioType,
    enableReinitialize: true,
    onSubmit: buscar
  }

  return <Formulario
    formik={parametrosFormik}
    restricoes={restricoes}
    operacao={OperacaoFormularioBusca.Buscar}
  >
    <div className="row">
      <div className='col-xs-8'>
        <Label htmlFor="nome">Nome</Label>
        <Input name="nome" id="nome" type="text" placeholder="Nome do servidor..." />
      </div>

      <div className='col-xs-4'>
        <Label htmlFor="situacao">Situação do servidor</Label>
        <VinculoServidorSelect inputId="situacao" name="situacao" />
      </div>

      <div className='col-xs-8'>
        <Label htmlFor="unidadeExercicio">Unidade</Label>
        <div><UnidadesCascaderStyled name="unidadeExercicio" /></div>
      </div>

      <div className='col-xs-4'>
        <Label htmlFor="restricaoUnidade">Restringir busca de servidores para</Label>
        <RestricaoUnidadeSelect inputId="restricaoUnidade" name="restricaoUnidade" />
      </div>
    </div>

    <FormikDebug />

    <footer>
      <BotaoSalvar textoOnLoading="Pesquisando">Pesquisar</BotaoSalvar>
      <BotaoCancelar type="button" onClick={onCancelar} />
    </footer>
  </Formulario>
}

const UnidadesCascaderStyled = styled(UnidadesUFCCascader)`
  width: 100%;
`;